export default __webpack_public_path__ + "static/media/img_baseRattle_lemon.cadb38fc.jpg";